import Icons from '@/icons/index'

const KNOWN_SIDEBAR_ICONS = new Set(Icons.getNameList())

/**
 * 侧栏 icon 依 enName 映射（对应 src/icons/svg/*.svg 文件名，不含 .svg）。
 */
export const SIDEBAR_ICON_BY_EN_NAME = {
  configProfileLibrary: 'file',
  coffeeMachineChannelSlots: 'nested',
  configBindDispatch: 'bind',
  simulatorGroup: 'machine_model',
  x600hGateway: 'link',
  xt90c2Simulator: 'machine',
  blenderSimulator: 'machine',
  xosIviSimulator: 'machine',
  hansonIviSimulator: 'machine',
  deviceLinkDebug: 'link',
  x600hProductionOrder: 'machine_model',
  leoKnowledgeGroup: 'documentation',
  leoKnowledgeModelFields: 'list',
  leoKnowledgeEquipmentTypeTypeKey: 'machine',
  leoKnowledgeUpload: 'upload',
  leoKnowledgeIngestBatch: 'clipboard',
  leoKnowledgePhase1Ssot: 'nested',
  leoKnowledgeCapabilityMatrix: 'table',
  leoKnowledgeOnboarding: 'guide',
  leoKnowledgeTesterConsole: 'operation',
  leoKnowledgePipelineHub: 'chart',
  leoKnowledgeFeatureSurface: 'link',
  leoKnowledgeProtocolDoc: 'documentation',
  leoKnowledgeRemoteTools: 'component',
  leoKnowledgeLearning: 'star',
  leoKnowledgeExternalIngest: 'file',
  leoKnowledgePortalHub: 'guide',
  leoKnowledgeUiSurfaceSample: 'theme',
  leoDeviceOpsRolePolicy: 'role',
  leoDeviceOpsSemanticTraining: 'edit',
  leoProductionE2eTraining: 'chart',
  leoTrainingDashboard: 'dashboard',
  leoT2GoldenTraining: 'star',
  leoT9DeepseekTraining: 'star',
  leoTurnRoutingTrainingHub: 'guide',
  leoCommandOnboardingWizard: 'guide',
  leoKnowledgePortalOpsInventory: 'clipboard',
  leoKnowledgePortalOpsDailyHub: 'documentation',
  leoDeviceOpsReviewInbox: 'list',
  leoDeviceOpsDescriptionAutogen: 'edit',
  leoDeviceOpsBLineDailyHub: 'documentation',
  leoXeeGrowthDashboard: 'chart',
  leoKnowledgeFolderPortal: 'guide',
  leoKnowledgeFolderModel: 'list',
  leoKnowledgeFolderIngest: 'upload',
  leoKnowledgeFolderProtocol: 'documentation',
  leoKnowledgeFolderOps: 'operation',
  memberHqGroup: 'peoples',
  memberHqDashboard: 'dashboard',
  memberHqFinance: 'money',
  memberHqOps: 'operation',
  distributorReportGroup: 'chart',
  distributorDashboard: 'pieChart',
  distributorMembers: 'user',
  distributorProfit: 'amount',
  homePage: 'star',
  dataDisplay: 'chart',
  atlas: 'pieChart',
  journal: 'documentation',
  details: 'eye',
  systemSetting: 'theme',
  loginAccount: 'user',
  authorization: 'role',
  merchants: 'peoples',
  devices: 'machine',
  material: 'materiel',
  deviceConfig: 'machine',
  channelConfiguration: 'link',
  productCenter: 'paper-cup',
  productCenterFolderBasic: 'list',
  productCenterFolderProducts: 'paper-cup',
  productCenterFolderMenu: 'nested',
  productCenterFolderChannels: 'bind',
  productCenterFolderAddons: 'materiel',
  productCenterFolderOther: 'component',
  dataCenter: 'chart',
  maintenance: 'operation',
  filesCenter: 'file',
  menuSetting: 'list',
  organization: 'organization',
  deviceList: 'machine',
  channelCategory: 'tab',
  productCategory: 'component',
  optionCategory: 'size',
  optionList: 'list',
  storeAccount: 'account',
  stores: 'online',
  modelName: 'machine',
  category: 'materiel',
  configDistribute: 'bind',
  devicesChannels: 'link',
  productsList5: 'list',
  posCenter: 'shopping',
  produceFivePos: 'shopping',
  menuDistribute: 'nested',
  storeMenu: 'list',
  merchantsData: 'pieChart',
  merchantData: 'pieChart',
  devicsData: 'chart',
  productionData: 'chart',
  maintanenceData: 'workOrder',
  devicesWorkingData: 'chart',
  afterSalesReminder: 'message',
  maintenanceTips: 'clipboard',
  fileUpgrade: 'software-upgrade',
  dataDowloan: 'download',
  materialList: 'list',
  accessoriesCategory: 'component',
  accessoriesList: 'list',
  businessCenter: 'money',
  appsBanner: 'message',
  advertisement: 'eye',
  advertBind: 'link',
  advertDistribute: 'upload',
  membersCenter: 'user',
  orderCenter: 'amount',
  packBag: 'paper-cup',
  appsCenter: 'component',
  productsList2: 'list',
  XTSeriesData: 'chart',
  materialDate: 'materiel',
  qualityData: 'chart',
  alertsLog: 'offline',
  cleaningLog: 'refresh',
  coffeeData: 'paper-cup',
  coffeeMachineProductionData: 'chart',
  coffeeMachineSingleCupData: 'maintain',
  coffeeSumData: 'chart',
  taxCenter: 'money',
  taxManagement: 'money',
  taxAllocation: 'amount',
  dataOfTeaExtractorMachine: 'chart',
  dataOfBlendExtractorMachine: 'chart',
  dataOfMilkExtractorMachine: 'chart',
  beverageOutputData: 'chart',
  singleCupData: 'chart',
  faultLog: 'offline',
  deliveryPlatform: 'link',
  uber: 'link',
  otherProducts: 'tab',
  listOfTeaExtractsProducts: 'list',
  machineDebug: 'operation',
  presetCommand: 'edit',
  commandConfiguration: 'component',
  operationAndMaintenanceServices: 'workOrder',
  productionList: 'list',
  smallMaterial: 'materiel',
  takeoutProducts: 'paper-cup',
  pointRule: 'star',
  couponManagement: 'money',
  couponList: 'list',
  additionalProducts: 'tab',
  type: 'size',
  produce: 'component',
  produceList4: 'list',
  smoothieMakerProduct: 'paper-cup',
  machineMenu: 'list',
  systemLog: 'message',
  region: 'organization',
  menuNav: 'nested',
  merchantTokenBillingPlatform: 'money',
  merchantDataBillingPlatform: 'money',
  linuxAutoOps: 'machine',
  linuxAutoEquipment: 'machine',
  linuxAutoRemoteOps: 'operation',
  linuxAutoProfileConfig: 'file',
  linuxAutoDataBilling: 'money',
  linuxAutoModelRegistry: 'list',
  linuxAutoPartnerDelivery: 'guide',
  linuxAutoFleetMonitor: 'chart',
  linuxAutoCanAutoMatch: 'link',
  linuxAutoDbcEntitlement: 'money',
  linuxAutoCabinFeatures: 'component',
  equipmentCategory: 'machine_model',
  produceData: 'chart'
}

function isLegacyElementIcon (icon) {
  return /^el-icon-/i.test(icon) || /^el-icon$/i.test(icon)
}

function isValidSidebarIcon (icon) {
  return icon && KNOWN_SIDEBAR_ICONS.has(icon) && !isLegacyElementIcon(icon)
}

/**
 * 解析单条侧栏菜单应展示的 SVG 图标名。
 */
export function resolveSidebarMenuIcon (menu) {
  if (!menu) return 'list'
  const hasChildren = Array.isArray(menu.menuList) && menu.menuList.length > 0
  const en = menu.enName != null ? String(menu.enName).trim() : ''
  const raw = menu.icon != null ? String(menu.icon).trim() : ''
  if (isValidSidebarIcon(raw)) return raw
  if (en && SIDEBAR_ICON_BY_EN_NAME[en] && isValidSidebarIcon(SIDEBAR_ICON_BY_EN_NAME[en])) {
    return SIDEBAR_ICON_BY_EN_NAME[en]
  }
  if (en && SIDEBAR_ICON_BY_EN_NAME[en]) return SIDEBAR_ICON_BY_EN_NAME[en]
  return hasChildren ? 'nested' : 'list'
}

/** 递归补齐侧栏树 icon（空值、Element 旧图标、未注册 SVG 名均会修正）。 */
export function fillSidebarMenuIcons (nodes) {
  if (!Array.isArray(nodes)) return
  for (let i = 0; i < nodes.length; i++) {
    const n = nodes[i]
    if (!n) continue
    if (Array.isArray(n.menuList) && n.menuList.length) {
      fillSidebarMenuIcons(n.menuList)
    }
    n.icon = resolveSidebarMenuIcon(n)
  }
}



// WEBPACK FOOTER //
// ./src/utils/sidebarMenuIcons.js